import Chip from '@mui/material/Chip';

import { ROTULOS_DE_ESTADO_DA_CONFERENCIA, type EstadoDaConferencia } from './api/tipos';

/**
 * Cor por TOKEN do design system, mesma disciplina de
 * `features/contratos/componentes/SeloDeEstadoDaFonte.tsx` (`DI14` do
 * TP-050): reaproveita `tema.palette.sla`, sem token novo no pacote.
 */
const TOM: Record<EstadoDaConferencia, 'ok' | 'atencao' | 'estourado' | 'semPrazo'> = {
  em_conferencia: 'semPrazo',
  segurada: 'atencao',
  liberada: 'ok',
  recusada: 'estourado',
};

export function SeloDeEstadoDaConferencia({ estado }: { estado: EstadoDaConferencia }): React.JSX.Element {
  return (
    <Chip
      size="small"
      label={ROTULOS_DE_ESTADO_DA_CONFERENCIA[estado]}
      sx={(tema) => {
        const tom = tema.palette.sla[TOM[estado]];
        return {
          backgroundColor: tom.fundo,
          color: tom.tinta,
          border: `1px solid ${tom.borda}`,
          fontWeight: 600,
          height: 20,
        };
      }}
    />
  );
}
